<template>
  <div class="app">
    <!-- <div class="address">
      <h4>
        {{ vm.city_name ? vm.city_name : ""
        }}{{ vm.address ? vm.address : "" }}户型
      </h4>
      <div class="casexian">
        <span class="mindianone"></span>
        <span class="dianone"></span>
        <span class="xianone"></span>
        <h5>安装案例</h5>
        <span class="xiantwo"></span>
        <span class="diantwo"></span>
        <span class="mindiantwo"></span>
      </div>
    </div> -->
    <!-- <h3>安装案例</h3> -->
    <!-- <div class="title">{{vm.content}}</div> -->
    <h3 class="tt">A.O.史密斯<br />用户安装实例</h3>
    <div class="user-infos">
      <div class="headimg">
        <img
          src="https://pro-core.babycdn.com/2020/08aosmith/images2020/release_case/headimg.jpg"
        />
      </div>
      <div class="info">
        <h3>案例信息</h3>
        <div class="txt">
          <span>城市：{{ vm.city_name }}</span
          ><span>小区：{{ vm.address }}</span>
        </div>
        <div class="txt" v-if="vm.house_area">面积：{{ vm.house_area }}m²</div>
      </div>
    </div>
    <!-- 限时福利 -->
    <div class="coupon-section-wrap long" v-if="arrActivityList.length">
      <h3>限时福利</h3>
      <ul>
        <li v-for="item in arrActivityList" :key="item.activityId">
          <div class="img-box">
            <img v-lazy="item.data.bannerUrl" :key="item.data.bannerUrl" />
          </div>
          <div class="detile-box">
            <h4>{{ item.data.activityName }}</h4>
            <h5>
              {{ item.data.startTime.substr(0, 10) }} 至
              {{ item.data.endTime.substr(0, 10) }}
            </h5>
            <div class="tips-box">
              <p class="pren">已有{{ item.data.enter }}人报名参加</p>
              <div class="sign-btn" @click="sginActivtiy(item.activityId)">
                立即报名
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 图文 -->
    <div class="case-item">
      <div v-if="vm.type == 0">
        <!-- <div class="subhead">{{vm.content}}</div> -->
        <div v-show="vm.reason">换购原因：{{ vm.reason }}</div>
        <video
          class="video"
          v-show="vm.mp4"
          v-lazy="vm.mp4"
          controls="controls"
        ></video>
        <img
          class="imgs"
          v-lazy="data.url"
          alt
          v-for="(data, index) in vm.imgs"
          :key="data.id"
          @click="swiperChange(index)"
        />
      </div>
      <div v-for="item in vm.new_scenes" :key="item.id" v-if="vm.type == 0">
        <!-- <div class="subhead">{{vm.content}}</div>
      <div v-show="vm.reason">换购原因：{{vm.reason}}</div>
        <video class="video" v-show="vm.mp4" v-lazy="vm.mp4" controls="controls"></video>-->
        <div v-for="(data, index) in item.house_img" :key="index">
          <img
            class="imgs"
            v-lazy="data.img_url"
            alt
            @click="swiperChange(indeximg)"
          />
        </div>
        <!-- 产品 -->
        <div class="goods-wrap" v-if="item.goods_info.length">
          <div class="titel">
            <span class="left"></span>
            案例中的商品
            <span class="right"></span>
          </div>
          <ul class="goods-list">
            <li
              v-for="git in item.goods_info"
              :key="git.id"
              @click="godetails(git.id)"
            >
              <div class="img-box">
                <img :src="git.mobile_thumb" />
              </div>
              <div class="title">
                <div>{{ git.goods_type_name }}</div>
                <div>{{ git.goods_name }}</div>
                <div
                  class="selling"
                  v-for="(gitem, gindex) in git.attr"
                  :key="gindex"
                  v-if="gitem.attr_mean < 4 && gindex < 3"
                >
                  <span style="margin-right: 10px">{{
                    gitem.attr_value ? "·" : ""
                  }}</span
                  >{{ gitem.attr_value ? gitem.attr_value : "" }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 视频 -->
      <div v-if="vm.type == 1">
        <video class="video" v-lazy="vm.mp4" controls="controls"></video>
        <div class="video-tips f32">{{ vm.content }}</div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="seller-box">
      <div
        class="info"
        v-if="arrCards.name || arrCards.mobile || arrCards.qrCode"
      >
        <div class="user-info">
          <div class="avatar">
            <img :src="arrCards.avatar" />
          </div>
          <h5>高级服务顾问</h5>
          <p>扫码联系 了解更多</p>
        </div>
        <div class="wrap-info">
          <div class="ercode-box">
            <div class="ercode">
              <img :src="arrCards.qrCode" />
            </div>
            <div class="content">
              <ul>
                <li>
                  <div class="lable">微信昵称</div>
                  <div id="nickname">{{ arrCards.name }}</div>
                </li>
                <li class="phone">
                  <div class="lable">电话</div>
                  <div id="phone">{{ arrCards.mobile }}</div>
                </li>
              </ul>
              <p>一键保存名片/添加好友</p>
            </div>
          </div>
        </div>
      </div>
      <div class="logo">
        <img src="@/assets/images/system/logo2.png" />
      </div>
    </div>
    <!-- @click="toAdv" -->
    <!-- <div v-show="banner">
      <img :src="vm.style==2?advImg[1]:advImg[0]" alt />
      <div class="advertising">
        <span class="icon">广告</span>
        <span class="anthor light">AO史密斯</span>
      </div>
    </div>-->

    <!-- <div v-show="showCode" class="code-img">
      <img src="~@/assets/images/case/xcx_code.jpg" alt="微信扫描二维码进入小程序，查看更多案例内容" />
      <p>长按识别或使用微信扫描二维码</p>
    </div>-->

    <!-- <div class="preview-img" v-show="showSwiper">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in arrSwiperImg" :key="item.id">
          <div class="swiper-zoom-container">
            <img v-lazy="item" alt />
          </div>
    </swiper-slide>-->
    <!--<div class="swiper-pagination "  slot="pagination"></div>-->
    <!-- </swiper>
    </div>-->
    <div v-show="showSwiper" class="close-preview" @click="closeSwiper">
      关闭预览
    </div>
  </div>
</template>

<script>
import path from "@/path.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      bShow: false,
      advImg: [
        "https://core.ali-cache.com/2019/xcx/ao_forum_page/image/adv01.jpg",
        "https://core.ali-cache.com/2019/xcx/ao_forum_page/image/adv02.jpg",
      ],
      caseType: "",
      vm: {
        card: {},
      },
      arrActivityList: [], //活动
      banner: false,
      showCode: false,
      swiperIndex: 2,
      swiperOption: {
        clickable: true,
        noSwiping: true,
        zoom: true,
        //                pagination: {
        //                    el: '.swiper-pagination',
        //                },
        on: {
          slideChangeTransitionStart: function (swiper) {
            this.swiperIndex = this.swiper.activeIndex;
          }.bind(this),
        },
      },
      arrSwiperImg: [],
      showSwiper: false,
      oShare: {},
      arrCards: [], //企业微信名片
    };
  },
  computed: {
    swiper() {
      this.swiperIndex = this.$refs.mySwiper.swiper.activeIndex;
      return this.$refs.mySwiper.swiper;
    },
  },
  watch: {
    //        swiperIndex: function(oldValue,newValue){
    //            this.swiper.slideTo(newValue, 1000, true)
    //        }
  },
  created() {
    this.getDetails();
    this.getCards();
  },
  methods: {
    //点击跳转详情页
    godetails(id) {
      //  console.log("商品id", id);
      wx.miniProgram.navigateTo({ url: `/pages/pro_type_v2/index?id=${id}` });
    },
    //案例详情
    async getDetails() {
      var that = this;
      let id = this.$route.query.topicid;
      //  console.log("userid", this.$route.query.userid);
      let data = {
        topic_id: id,
        source: "xcx",
        user_id: this.$route.query.userid,
        activity_id: this.$route.query.sShareIds || "",
      };
      // path.topicDetailsUrl
      this.$store.commit("loadSwitch", true);
      let oDetails = await path.post5(path.gettopic, data);
      this.$store.commit("loadSwitch", false);
      var objCaseInfo = oDetails.data.data.result;
      //  console.log("oDetails", objCaseInfo);
      this.vm = objCaseInfo;
      this.arrActivityList = objCaseInfo.activity;
      this.banner = true;
      this.showCode = true;
      var arrImgs = objCaseInfo.imgs;
      var arrSwiperImg = [];
      arrImgs.forEach(function (item, index, arr) {
        if (item.is_image == 1) {
          arrSwiperImg.push(item.url);
        }
      });
      that.arrSwiperImg = arrSwiperImg;
    },
    //收藏案例
    getcollection() {
      let data = {
        type: "topic",
        user_id: this.$route.query.userid,
        xid: this.vm.id,
        title:
          this.vm.province_name +
          "-" +
          this.vm.city_name +
          "-" +
          this.vm.address,
        source: "xcx",
      };
      this.$store.commit("loadSwitch", true);
      path.post5(path.getcollect, data).then((res) => {
        //  console.log("收藏案例", res);
        if (res.data.error == 0) {
          this.$store.commit("loadSwitch", false);
          this.$toast({
            message: res.data.data.result.msg,
            duration: 500,
          });
          this.getDetails();
        }
      });
    },
    getCards() {
      let data = {
        source: "xcx",
        user_id: this.$route.query.tp5Userid,
      };
      path.post5(path.getCards, data).then((res) => {
        let arrCards = res.data.data.result;
        this.arrCards = arrCards;
      });
    },
    // 报名活动
    sginActivtiy(id) {
      wx.miniProgram.navigateTo({
        url: `/pages/watersystem/miniprogram/index?sAppId=${path.APPID}&sEnvVersion=${path.envVersion}&sId=${id}&topicid=${this.$route.query.topicid}`,
      });
    },
    swiperChange(index) {
      var that = this;
      //  console.log(index);
      if (index >= 0) {
        that.showSwiper = true;
        that.swiper.slideTo(index, 1000, true);
      }
    },
    closeSwiper() {
      var that = this;
      that.showSwiper = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  padding-bottom: 132px;
  box-sizing: border-box;
  min-height: 100vh;
  width: 100%;
  position: relative;
  padding-bottom: 151px;
  background:url(~@/assets/images/user/top.png) no-repeat 0 0/100% auto;
  .tt {
    position: relative;
    text-align: center;
    font-size: 44px;
    color: #fff;
    padding: 80px 0 120px;
  }
}
.case-item {
  margin: 0 auto 40px;
  padding-top: 30px;
  padding-bottom: 50px;
  background: url(~@/assets/images/case/sub_long_bg.png) repeat top;
}
.popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  margin: auto;
}
.kuang {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 657px;
  height: 221px;
  background-color: #ffffff;
  border-radius: 11px;
  margin: auto;
  z-index: 99999;

  .top {
    font-size: 30px;
    height: 126px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bottom {
    height: 94px;
    font-size: 30px;
    width: 100%;
    display: flex;

    div {
      width: 50%;
      height: 94px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #bdbdbd;
    }

    div:last-child {
      border-left: 1px solid #bdbdbd;
      color: #263167;
    }
  }
}

.btn {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 30px auto 30px auto;

  .collection {
    width: 243px;
    height: 91px;
    border-radius: 45px;
    background-color: #f0a400;
    display: flex;
    font-size: 39px;
    align-items: center;
    color: #fff;
    justify-content: center;
  }

  .sharecollection {
    width: 464px;
    height: 91px;
    font-size: 39px;
    color: #fff;
    border-radius: 45px;
    background-color: #263167;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 12px;
  }
}
.body {
  padding: 30px 30px 30px 30px;
}

.title {
  font-size: 32px;
  margin-bottom: 20px;
  padding: 10px 30px;
  background: url(~@/assets/images/case/sub_bg.png) no-repeat center/100% 100%;
}
.head {
  height: 76px;
  .head-icon {
    width: 76px;
    height: 76px;
    border-radius: 50%;
    background-color: #e8e8e8;
  }
  .name {
    width: 440px;
    float: left;
    margin-left: 20px;
    .text-bold {
      font-size: 26px;
      margin-bottom: 5px;
    }
    div {
      width: 440px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .page-div {
    width: 120px;
    color: #999;
  }
}
.subhead {
  margin: 20px 0;
  font-size: 26px;
}

.imgs {
  display: block;
  margin: 30px auto;
  width: 690px;
  min-height: 300px;
  background-color: #e2e2e2;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.advertising {
  margin: 10px 0;
  .icon {
    display: inline-block;
    line-height: 32px;
    text-align: center;
    border: 1px solid #27437f;
    color: #27437f;
    border-radius: 3px;
    margin-right: 20px;
  }
  span {
    font-size: 24px;
  }
  .light {
    color: #999;
  }
}

.video {
  width: 690px;
  height: 450px;
  margin: 30px auto;
  background-color: #333;
}
.video-tips {
  margin: 30px auto;
}
.code-img {
  display: block;
  /*justify-content: space-between;*/
  /*align-items: flex-start;*/
  & > img {
    display: block;
    width: 200px;
    margin: 0 auto;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  & > p {
    /*white-space: nowrap;*/
    font-size: 28px;
    text-align: center;
    line-height: 1.5;
    margin-top: 20px;
    color: #999;
    padding: 0 50px;
  }
}
.preview-img {
  display: block;
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
}
.close-preview {
  width: 600px;
  height: 80px;
  background-color: #1f2e5f;
  color: #fff;
  text-align: center;
  line-height: 80px;
  position: fixed;
  left: 50%;
  bottom: 30px;
  margin-left: -300px;
  font-size: 32px;
  border-radius: 40px;
  z-index: 19;
}
// 优惠券
.coupon-section-wrap {
  padding: 30px 20px 45px 20px;
  background-color: #ffffff;

  // margin-top: 20px;
  &.long {
    ul {
      flex-wrap: wrap;

      li {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .img-box {
          width: 216px;
          height: 170px;
        }

        .detile-box {
          width: calc(100% - 256px);
          position: relative;

          .tips-box {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
          }
        }
      }
    }
  }

  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // margin-top: 20px;
    flex-wrap: wrap;

    li {
      width: 346px;
      background-color: #ffffff;
      box-shadow: 0px 5px 8px 0px rgba(13, 5, 9, 0.15);
      padding: 20px;
      margin-bottom: 20px;

      .img-box {
        height: 130px;
        background-color: #ffffff;
        border-radius: 10px;
        overflow: hidden;
      }

      .detile-box {
        margin-top: 15px;

        h4 {
          color: #282828;
          font-size: 24px;
          line-height: 30px;
          white-space: nowrap;
          height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        h5 {
          color: #000000;
          font-size: 24px;
          font-weight: normal;
        }

        .tips-box {
          color: #282828;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;

          p {
            // width: 180px;
          }

          .sign-btn {
            width: 120px;
            height: 40px;
            border: solid 1px #000000;
            color: #282828;
            font-size: 22px;
            text-align: center;
            line-height: 40px;
            border-radius: 20px;
          }
        }
      }
    }
  }
}
.address {
  // width: 710px;
  min-height: 213px;
  box-sizing: border-box;
  margin: 0 auto 0 auto;
  overflow: hidden;
  padding: 30px;
  background: url(~@/assets/images/case/sub_bg.png) no-repeat center/100% 100%;
  h4 {
    color: #263167;
    font-size: 40.05px;
    line-height: 60rpx;
    text-align: center;
    margin-top: 20px;
  }
  .casexian {
    margin-top: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    h5 {
      color: #263167;
      font-size: 40.05px;
      line-height: 60rpx;
      // position: relative;
      margin: 0 15px;
      display: inline-block;
      // transform: translateX(-50%);
      // left: 50%;
      // margin-top: 10px;

      // &::after {
      //     content: '';
      //     width: 112px;
      //     height: 2px;
      //     background-color: #263167;
      //     position: absolute;
      //     top: 0;
      //     bottom: 0;
      //     margin: auto 0;
      //     right: - 142px;
      // }

      // &::before {
      //     content: '';
      //     width: 112px;
      //     height: 2px;
      //     background-color: #263167;
      //     position: absolute;
      //     top: 0;
      //     bottom: 0;
      //     margin: auto 0;
      //     left: - 142px;
      // }
    }

    .xianone {
      width: 12px;
      height: 12px;
      margin-left: 8px;
      display: inline-block;
      background: url(~@/assets/images/case/squareone_icon.png) no-repeat
        center/100% 100%;
    }

    .xiantwo {
      width: 12px;
      height: 12px;
      display: inline-block;
      background: url(~@/assets/images/case/squareone_icon.png) no-repeat
        center/100% 100%;
      margin-right: 8px;
    }

    .dianone {
      width: 9px;
      height: 9px;
      display: inline-block;
      background: url(~@/assets/images/case/squaretwo_icon.png) no-repeat
        center/100% 100%;
      margin-left: 8px;
    }

    .diantwo {
      width: 9px;
      height: 9px;
      margin-right: 8px;
      display: inline-block;
      background: url(~@/assets/images/case/squaretwo_icon.png) no-repeat
        center/100% 100%;
    }

    .mindianone {
      width: 6px;
      height: 6px;
      display: inline-block;
      background: url(~@/assets/images/case/squarethree_icon.png) no-repeat
        center/100% 100%;
    }

    .mindiantwo {
      width: 6px;
      height: 6px;
      display: inline-block;
      background: url(~@/assets/images/case/squarethree_icon.png) no-repeat
        center/100% 100%;
    }
  }

  .top {
    font-size: 36px;
    color: #263167;
    font-weight: 700;
  }

  .bottom {
    height: 100px;
    margin-top: 32px;
    display: flex;
    width: 100%;

    .item {
      width: 50%;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      div {
        font-size: 30px;
        color: #282828;
      }
    }
  }
}
// h3 {
//   font-weight: normal;
//   width: 100%;
//   height: 57px;
//   background-color: #263167;
//   font-size: 32px;
//   color: #ffffff;
//   text-align: center;
//   line-height: 57px;
//   margin: auto;
// }
// 底部
.seller-box {
  background-color: #ffffff;
  margin-top: 20px;
  overflow: hidden;
  padding: 0 0 30px 0;
  // height: 520px;
  .info {
    display: flex;
    justify-content: space-between;
    .user-info {
      color: #000000;
      h5 {
        font-size: 24px;
        line-height: 39.75px;
        margin-top: 7.5px;
      }
      p {
        font-size: 14.25px;
        text-align: center;
      }
    }
    .avatar {
      width: 123px;
      height: 123px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #ffffff;
      margin-top: 30px;
    }
    .wrap-info {
      width: 509.25px;
      position: relative;
      padding: 22.5px;
      &::before {
        content: "";
        width: 0;
        height: 0;
        border: 22.5px solid transparent;
        border-right-color: #203a72;
        position: absolute;
        left: -40px;
        top: 64.5px;
        // bottom: 0;
        // margin: auto 0;
      }
      background-color: #203a72;
      border-radius: 8.25px;
    }
    .news {
      width: 437.25px;
      height: 54.75px;
      position: relative;
      background: url(~@/assets/images/system/audio3.png?v=2) no-repeat
        center/100% 100%;
      .time {
        color: #afafaf;
        font-size: 20.25px;
        position: absolute;
        right: 0;
        top: 22.5px;
      }
      &.play {
        animation: audio 1s linear infinite;
      }
    }
  }
  .ercode-box {
    display: flex;
    align-items: center;
    height: 198.75px;
    .ercode {
      width: 171px;
      height: 171px;
      overflow: hidden;
      background-color: #ffffff;
    }
    .content {
      color: #ffffff;
      font-size: 24px;
      margin-left: 30px;
      ul {
        color: #ffffff;
        line-height: 52.5px;
        li {
          display: flex;
          align-items: center;
          position: relative;
          height: 52.5px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          .lable {
            margin-right: 26.25px;
            position: relative;
            vertical-align: top;
            height: 52.5px;
            &::before {
              content: "：";
              position: absolute;
              right: -30px;
              top: 0;
              bottom: 0;
              margin: auto 0;
            }
            &::after {
              display: inline-block;
              width: 100%;
              content: "";
              height: 0;
            }
          }
        }
      }
    }
  }
  .logo {
    width: 217px;
    height: 80px;
    margin: 67.5px auto;
    // background: url(~@/assets/images/system/logo2.png) no-repeat center/100% 100%;
  }
}
.goods-wrap {
  margin-top: 79px;
  padding: 0 30px;
  .titel {
    font-size: 36px;
    color: #4c4c4c;
    display: flex;
    align-items: center;
    justify-content: center;
    .left {
      width: 64px;
      height: 3px;
      display: inline-block;
      background: #4c4c4c;
      margin-right: 17px;
    }
    .right {
      width: 64px;
      height: 3px;
      display: inline-block;
      background: #4c4c4c;
      margin-left: 17px;
    }
  }
  .goods-list {
    margin-top: 30px;
    width: 710px;
    margin: 43px auto 0 auto;
    height: auto;
    overflow: hidden;
    border-radius: 17px;
    width: 100%;
    padding: 0 44px;
    box-sizing: border-box;
    background-color: #f5f5f5;
    // display: flex;
    // flex-wrap: wrap;

    // justify-content: space-between;
    > li {
      width: 100%;
      height: 250px;
      background-color: #f5f5f5;
      // border-radius: 17px;
      display: flex;
      // margin-bottom: 16px;
      // padding: 10px 49px;
      border-bottom: dashed 2px #4c4c4c;
      // flex-wrap: wrap;
      align-items: center;
      // justify-content: space-between;
      // margin-right: 10px;

      .img-box {
        width: 190px;
        // height: 164px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 190px;
        }
      }

      .title {
        color: #282828;
        font-size: 24px;
        height: auto;
        // overflow: hidden;
        width: 100%;
        margin-left: 18px;

        // margin-top: 10px;
        div {
          font-size: 30px;
          // width: 124px;
          // overflow: hidden;
          // white-space: nowrap;
          // text-overflow: ellipsis;
        }
        .selling {
          display: flex;
          align-items: center;
          font-size: 20px;
          color: #282828;
          margin-top: 5px;
          span {
            margin-right: 10px;
          }
          // &::before{
          //     content: "·";
          //     display: inline-block;
          //     margin-right: 10px;
          // }
        }
      }

      .content {
        width: 540px;
        padding-left: 22.5px;
        position: relative;
        height: inherit;

        p {
          line-height: 66px;
          color: #282828;
          font-size: 25.5px;
          height: 66px;
          border-bottom: solid 0.75px #f3f8fd;
        }

        ol {
          height: 124.5px;
          font-size: 17.25px;
          line-height: 30px;
          color: #282828;
        }

        .btn {
          width: 129.75px;
          height: 32.25px;
          background-color: #eef6ff;
          text-align: center;
          line-height: 32.25px;
          position: absolute;
          right: 22.5px;
          bottom: 15px;
          color: #053162;
          font-size: 20.25px;
        }
      }
    }
    > li:last-child {
      border: 0;
    }
  }
}
.user-infos {
  width: 700px;
  height: 276px;
  margin: 0 auto 40px;
  background: #fff url(~@/assets/images/user/bg.png) no-repeat 0 0/100% auto;
  border-radius: 20px;
  position: relative;
  padding-top: 100px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
  .headimg {
    position: absolute;
    top: 0;
    left: 50%;
    width: 110px;
    height: 110px;
    margin-top: -55px;
    margin-left: -55px;
    border-radius: 50%;
    overflow: hidden;
  }
  .info {
    width: 520px;
    margin: 0 auto;
    h3 {
      font-size: 32px;
      color: #6d7278;
      margin-bottom: 10px;
      text-align: center;
      position: relative;
      &:after,
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        width: 32%;
        height: 1px;
        background: rgba(109, 114, 120, 0.6);
      }
      &:after {
        right: 0;
      }
      &:before {
        left: 0;
      }
    }
    .txt {
      font-size: 26px;
      margin-bottom: 10px;
      color: #6d7278;
      span {
        margin-right: 30px;
      }
      // &:last-child{
      span:last-child {
        margin-right: 0;
      }
      // }
    }
  }
}
</style>
